module.exports = __webpack_public_path__ + "static/img/A154.d2bab97b.jpg";